<template>
  <div v-show='!$store.state.isLoading'>
    <el-row
      type="flex"
      justify="center"
      style="margin: 0 16px;"
      v-if="!orderDetailErrorRsp"
    >
      <el-col
        class="payment-box"
        :xs="24"
        :sm="20"
        :md="16"
        :lg="10"
        :xl="8"
      >
        <el-alert v-if="orderInfo.transStatus === 'SUCCEED'" :title="$t('payment.successPayStatus')" type="success" center :closable="false"></el-alert>
        <div>
          <span class="order-label-confirm">{{$t('payment.orderConfirmNo')}}:</span>
          <span class="order-value order-value-confirm">{{orderInfo.orderConfirmNo}} &nbsp;</span>
        </div>
        <div class="order-info">
          <div class="custom-info">{{$t('payment.customerInfo')}}</div>
          <div class="order-item">
            <span class="order-label">{{$t('payment.name')}}:</span>
            <span class="order-value">{{orderInfo.guestName}}</span>
          </div>
          <div class="order-item">
            <span class="order-label">{{$t('payment.email')}}:</span>
            <span class="order-value">{{orderInfo.guestEmail}}</span>
          </div>
        </div>
        <div class="deposit-desc">
          <span class="color-red">* </span>
          <span v-html="$t('payment.depositDesc')"></span>
        </div>
        <div class="pay-total">
          <div class="pay-item">
            <span class="pay-item-label">{{$t('payment.totalAmount')}}: </span>
            <span class="pay-item-value color-red">{{orderInfo.amount}} {{orderInfo.currency}}</span>
          </div>
          <div class="pay-item">
            <span class="pay-item-label">{{$t('payment.status')}}: </span>
            <span
              class="pay-item-value order-amount-color"
              v-if="orderInfo.transStatus === 'INIT'"
            >{{$t('payment.notPayStatus')}}</span>
            <span
              class="pay-item-value order-amount-color"
              style="color: green"
              v-else-if="orderInfo.transStatus === 'SUCCEED'"
            >{{$t('payment.successPayStatus')}}</span>
          </div>
        </div>
        <div v-show="orderInfo.transStatus !== 'SUCCEED'">
          <div class="order-info pay-way-type">
            <div>
              <span class="custom-info">{{$t('payment.payWay')}}</span>
              <span class="pay-way-icon">Stripe</span>
            </div>
            <div class="pay-attention">{{$t('payment.payAttention')}}</div>
            <div style="display: flex; margin-top: 8px; align-items: center">
              <span>{{$t('payment.receiptEmail')}}</span>
              <el-input
                type="email"
                style="margin-left: 8px"
                size="small"
                v-model="receiptEmail"
                :placeholder="$t('payment.receiptEmailContent')">
              </el-input>
            </div>
            <form id="payment-form" style="margin-top: 8px;">
              <div class="form-row">
                <span>
                  {{$t('payment.creditCard')}}
                </span>
                <div id="error-message" style="color: red; white-space: normal"></div>
                <div id="card-element">
                </div>
                <div
                  id="card-errors"
                  role="alert"
                  style="height: 20px;padding: 4px 0;color: #fa755a;"
                ></div>
              </div>
              <button v-if="submitBtnVisible" class="button" type="submit" v-html="$t('payment.submitText')"></button>
            </form>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row
      v-else
      style="padding: 0 16px;"
    >
      <el-card style="max-width:400px; margin: 16px auto;">
        <el-alert
          :title="orderDetailErrorRsp.code"
          type="error"
          :closable="false"
          :description="orderDetailErrorRsp.msg"
          show-icon
        >
        </el-alert>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import { paymentDetail, submitReceiptEmail } from '@/api/pay' // paymentDetail

export default {
  name: 'Pay',
  data () {
    return {
      submitBtnVisible: true,
      orderInfo: {
        amount: null,
        currency: '',
        guestName: '',
        guestEmail: '',
        orderConfirmNo: '',
        transStatus: '',
        payAccount: '',
      },
      transAccessToken: '', // 'BRrp3sV3Qaqj5aFNdhdehNsV12OfjvUhuOcSH8cQxlDeLNhfZbvmDH9BOYCEs4fo-Nf8HvEMig_lCR2IMDAngRSaO3kSuPjl',
      receiptEmail: '',
      stripe: null,
      orderDetailErrorRsp: null,
    }
  },
  watch: {
    $route (to, from) {
      this.loadDetail()
    },
    '$i18n.locale' (val) {
      this.initStripe()
    },
  },
  created () {
    const queryParams = this.$route.query || {}
    this.transAccessToken = queryParams.transAccessToken
    this.loadDetail() // 获取订单信息
  },
  mounted () {
  },
  methods: {
    async loadDetail () {
      this.$store.commit('showLoading', { isLoading: true })
      const res = await paymentDetail({ transAccessToken: this.transAccessToken }).finally(() => {
        this.$store.commit('showLoading', { isLoading: false })
      })
      if (res.code === '200') {
        const resultData = res.data
        this.$store.commit('userInfo/update', resultData.guestName || 'Guest')

        this.orderInfo = {
          ...resultData,
        }
        if (!this.orderInfo.stripeClientSecret || this.orderInfo.transStatus === 'SUCCEED') {
          return
        }
        // 初始化stripe
        let stripe
        // const stripe = await loadStripe('pk_test_ILPAeQbZcAYVW6zrvDMAXlLR')
        if (window.location.origin.indexOf('dev') > -1 || window.location.origin.indexOf('test') > -1) {
          // stripe = await loadStripe('pk_test_LYqtmXN1jqh9hMye1ezowg1r') // dev 环境
          stripe = await loadStripe('pk_test_ILPAeQbZcAYVW6zrvDMAXlLR') // dev 环境
          if (this.orderInfo.currency === 'AUD') {
            stripe = await loadStripe('pk_test_I8M5phCIBrg6AfDgzCWdoMph')
          }
        } else {
          // prod环境
          if (this.orderInfo.payAccount === 'Ostay') {
            stripe = await loadStripe('pk_live_j2ETyDaK5uAQ3hEGxJzRxILo')
          } else if (this.orderInfo.payAccount === 'Samty') {
            stripe = await loadStripe('pk_live_BkewCi9zh8kD36dSaIQ3Le0i')
          } else {
            // 默认STRIPE_JAPAN_OSTAY
            stripe = await loadStripe('pk_live_j2ETyDaK5uAQ3hEGxJzRxILo')
          }
        }
        this.stripe = stripe
        this.initStripe()
      } else {
        this.orderDetailErrorRsp = res
      }
    },
    initStripe () {
      // Create an instance of Elements.
      if (!this.stripe) {
        return
      }
      const elements = this.stripe.elements({
        locale: this.$i18n.locale || 'en', // 设置默认显示语种 en 英文 zh 中文 ja 日语
        clientSecret: this.orderInfo.stripeClientSecret,
        appearance: {
        },
      })
      // Custom styling can be passed to options when creating an Element.
      // (Note that this demo uses a wider set of styles than the guide below.)
      // Create an instance of the card Element.
      const paymentElement = elements.create('payment')
      // Add an instance of the card Element into the `card-element` <div>.
      paymentElement.mount('#card-element')
      // Handle real-time validation errors from the card Element.
      // Handle form submission.
      const form = document.getElementById('payment-form')
      const _this = this

      form.addEventListener('submit', async function (event) {
        event.preventDefault()
        if (_this.receiptEmail) {
          submitReceiptEmail({
            transAccessToken: _this.transAccessToken,
            receiptEmail: _this.receiptEmail,
          })
        }
        _this.submitBtnVisible = false
        const { error } = await _this.stripe.confirmPayment({
          // `Elements` instance that was used to create the Payment Element
          elements,
          confirmParams: {
            return_url: window.location.href,
          },
          redirect: 'if_required',
        })

        if (error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          const messageContainer = document.querySelector('#error-message')
          messageContainer.textContent = error.message
          _this.submitBtnVisible = true
        } else {
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
          _this.orderInfo.transStatus = 'SUCCEED'
        }
      })
    },
  },

}
</script>

<style scoped>
.el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  font-size: 16px !important;
  padding: 2px 8px !important;
  border: 1px solid #eabfbf !important;
}
.StripeElement {
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #83b3ee;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.el-step__title.is-finish {
  color: #67c23a !important;
  font-size: 14px !important;
}
.el-step__head.is-finish {
  color: #67c23a !important;
  border-color: #67c23a !important;
  font-size: 14px !important;
}
.el-step__title.is-process {
  font-size: 14px !important;
}
.el-steps {
  justify-content: center;
}
.el-step__title {
  line-height: 22px !important;
  margin-top: 6px;
}
</style>

<style scoped>
.payment-box {
  margin: 16px 0;
  padding: 8px 16px;
  border: 1px solid #dfdfdf;
  background-color: rgb(255, 255, 255);
}
.pay-contain {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin: 0;
}
.pay-title {
  line-height: 40px;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  font-size: 28px;
}
.order-info {
  color: #333333;
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  margin-top: 8px;
  border-top: 1px solid #f0f0f0;
}
.order-item {
  display: flex;
  flex-direction: row;
  line-height: 30px;
}
.order-label {
  color: #a7a4a4;
  font-size: 14px;
  text-align: left;
  margin-right: 8px;
}
.order-value {
  font-weight: 500;
  font-size: 14px;
}
.order-value-confirm {
  font-weight: 500;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
.order-amount-color {
  font-size: 16px;
  color: #d68b1d;
}
.deposit-desc {
  font-size: 13px;
  color: #a7a4a4;
  line-height: 22px;
  white-space: normal;
}
.color-red {
  color: red;
}
.receipt-email {
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
}
.email-label {
  margin-right: 8px;
  font-size: 14px;
  line-height: 35px;
  color: rgb(107, 124, 147);
}
.email-input {
  flex: 1;
}
.credit-card {
  display: flex;
  flex-direction: column;
}
.card-label {
  color: #6b7c93;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
}
.button {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  font-weight: 600;
  background-color: #32325d;
  border: none;
  border-radius: 8px;
  /* box-shadow: 0 9px #999; */
  margin-top: 10px;
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.steps-contain {
  position: relative;
  margin: 0 auto;
  margin-top: 35px;
  margin-bottom: 30px;
}
.order-confirmNo {
  display: flex;
  flex-direction: row;
  height: 25px;
  line-height: 25px;
  padding: 10px;
  background: #f0f0f0;
  margin-bottom: 25px;
}
.order-label-confirm {
  color: #a7a4a4;
  font-size: 12px;
  margin-right: 6px;
}
.custom-info {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: 500;
}
.pay-total {
  display: flex;
  flex-direction: column;
  margin: 8px 0;
  align-items: flex-end;
  background: #f0f0f0;
  padding: 4px 8px;
  line-height: 30px;
}
.pay-item {
  display: flex;
  flex-direction: row;
  width: 210px;
}
.pay-item-label {
  color: #a7a4a4;
  width: 100px;
  font-size: 14px;
  text-align: right;
}
.pay-item-value {
  flex: 1;
  text-align: right;
}
.pay-button-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding-bottom: 18px;
}
.pay-button {
  border: 1px solid red;
  color: red;
  padding: 8px 18px !important;
}
.pay-way-icon {
  line-height: 35px;
  width: 65px;
  background: #000;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 4px 8px;
  margin-left: 8px;
  font-style: italic;
}
.pay-attention {
  color: #c9c9c9;
  font-size: 13px;
  white-space: normal;
  line-height: 22px;
}
.error-title {
  color: red;
}
.request-error {
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.repay-button-small {
  border: 1px solid red;
  color: red;
}
</style>
